import { render } from "./autoparts.vue?vue&type=template&id=5de75195"
import script from "./autoparts.vue?vue&type=script&lang=js"
export * from "./autoparts.vue?vue&type=script&lang=js"

import "./autoparts.vue?vue&type=style&index=0&id=5de75195&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__